import React from "react";

export const Icons = () => {
  return (
    <div className="iconsContainer">
      <img className="hearticons" src="../icons/heart.svg" alt="heart icon" />
      <img className="playicons" src="../icons/play.svg" alt="play icon" />
      <img className="dotsicons" src="../icons/dots.svg" alt="dots icon" />
    </div>
  );
};
